<template>
    <div id="pt485" class="pt485" v-cloak>
        <breadcrumb :navListCustom="[{title:$t('common.labels.myPgage'), routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('common.labels.couponList'), routerName: '', param: {}}]"></breadcrumb>
        <div>
            <h2>{{$t('pt485.labels.title')}}</h2>
            <!--<h2>{{$t('common.labels.titleHeaderOrder')}}</h2>-->
            <div class="pt485Main">
                <!--<div class="itemTitle">
                    <h3 >{{$t('pt485.labels.title')}}</h3>
                </div>-->
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT485_PART" class="p-3" /> 
                <div class="couponAddInfo">
                    <span>{{ $t('pt485.labels.couponAddTitle') }}</span>
                    <div class="couponSearch">
                        <input-check size="20" type="text" :maxlength="20" class="couponInput code" v-model="pt485ReqModel.searchCouponCd"/>
                        <input class="btnAdd" type="button" @click="add();" :value="$t('pt485.buttons.add')">
                    </div>
                    <span v-html="descriptionInfo[1]"></span>
                </div>
                
                <hr class="divider">

                <template v-if="showFlg">
                    <div class="couponHeader">
                        <div class="kakuteiContainer" v-if="pt485ReqModel.modeKbn == '1'">
                            <input class="btnKakutei" type="button" @click="kakuteiCheck();" :value="$t('pt485.buttons.btnKakutei')">
                        </div>
                        <div :class="pt485ReqModel.modeKbn == '1'? 'sortList50':'sortList'">
                            <div style="display:flex;flex-direction: row;justify-content: space-between;">
                                <div><span>{{$t('pt485.labels.sortTitle')}}:</span></div>
                                <div style="display:inline-flex"> 
                                    <input class="riyouzumiCheck mr-2" type="checkbox" 
                                                v-model="pt485ReqModel.riyouzumiFlg"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="reSearch()">
                                    <span>{{$t('pt485.labels.riyouzumi')}}</span>
                                </div>
                            </div>
                            
                            <select class="sortKbn" v-model="pt485ReqModel.sortKbn" @change="reSearch">
                                <option v-for="(sortKbn,idx) in pt485Init.sortKbnList" :key="idx" :value="sortKbn.KEY">{{ sortKbn.VALUE}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="couponContainer">
                        <ul>
                            <li  v-for="(coupon, index) in pt485Init.couponList" :key="index" :class="(coupon.COUPON_DISABLED == '0' && coupon.NOT_USE_JOUKEN_KIN_FLG == '0' && coupon.NOT_USE_SYOHIN_FLG == '0' && coupon.USE_LIMIT_YMD_FROM_FLG == '0' || coupon.SYOHIN_QTY_LIMITED_FLG == '0')?'couponList':(coupon.RIYOU_ZUMI_FLG == '0')?'couponListDisabled':'couponListRiyouZumi'">
                                <div class="couponItem">
                                    <div class="couponItemLeft" v-if="pt485ReqModel.modeKbn == '1' && coupon.RIYOU_ZUMI_FLG == '0'">
                                        <input class="couponCheck" type="checkbox" 
                                            v-model="coupon.COUPON_SELECTED" 
                                            :disabled="coupon.COUPON_DISABLED == '1' || coupon.NOT_USE_JOUKEN_KIN_FLG == '1' || coupon.NOT_USE_SYOHIN_FLG == '1' || coupon.USE_LIMIT_YMD_FROM_FLG == '1' || coupon.SYOHIN_QTY_LIMITED_FLG == '1'"
                                            @change="selectedCoupon(coupon.COUPON_CD, coupon.COUPON_SELECTED, coupon.HEIYOU_FLG)">
                                        
                                    </div>
                                    <div class="couponItemRight" v-if="coupon.DISP_IMAGE_KBN == 0">
                                        <ul class="couponInfo">
                                            <li>
                                                <div class="couponFirstLine">
                                                    <div class="couponTitle">
                                                        {{ coupon.COUPON_TITLE }}
                                                    </div>
                                                    <div v-if="coupon.USE_JOUKEN == '2'" class="couponObjectCondition">
                                                        <a v-on:click="showItemListModal(coupon.COUPON_CD)" href="javascript:void(0)">
                                                            {{ $t('pt485.labels.couponConditionShohin') }}
                                                            <img clas="couponObjectImg" :src="getImageOpenNewWindow" alt="対象商品">
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li v-if="coupon.COUPON_YOUTO_KBN == 'D'"><strong>{{ formatPrice(coupon.COUPON_NUM) }}</strong>{{$t('pt485.labels.couponYouToKbnD')}}</li>
                                            <li v-else-if="coupon.COUPON_YOUTO_KBN == 'P'"><strong>{{ formatPrice(coupon.COUPON_NUM) }}</strong>{{$t('pt485.labels.couponYouToKbnP')}}</li>
                                            <li v-else-if="coupon.COUPON_YOUTO_KBN == 'R'"><strong>{{ formatPrice(coupon.COUPON_NUM) }}</strong>{{$t('pt485.labels.couponYouToKbnR')}}</li>
                                            <li v-if="coupon.USE_JOUKEN == '0'">{{$t('pt485.labels.couponConditionTitle')}}{{$t('pt485.labels.couponConditionNo')}}</li>
                                            <li v-else-if="coupon.USE_JOUKEN == '1'">{{$t('pt485.labels.couponConditionTitle')}}{{$t('pt485.labels.couponConditionKinPre')}}<strong>{{ formatPrice(coupon.USE_JOUKEN_KIN) }}</strong>{{$t('pt485.labels.couponConditionKinAft')}}</li>
                                            <li v-if="coupon.USE_JOUKEN == '2'">{{$t('pt485.labels.couponConditionTitle')}}{{$t('pt485.labels.couponConditionShohinBuy')}}</li>
                                            <li>{{ $t('pt485.labels.couponLimitYmdTo') }}<strong>{{ coupon.USE_LIMIT_YMD_FROM }}～{{ coupon.USE_LIMIT_YMD_TO }}</strong></li>
                                            <li>{{ $t('pt485.labels.couponHeiYou') }}{{ coupon.HEIYOU_FLG == '0'? $t('pt485.labels.couponNo'):$t('pt485.labels.couponYes') }}</li>
                                            <li>
                                                <div class="kurikaeshiFuyoYmd">
                                                    <div class="couponKurikaeshi">{{ $t('pt485.labels.couponKurikaeshi') }}{{ coupon.KURIKAESHI_FLG == '0'? $t('pt485.labels.couponNo'):$t('pt485.labels.couponYes') }}</div>
                                                    <div class="fuyoYmd">{{ $t('pt485.labels.fuyoYmd') }}<strong>{{ coupon.FUYO_YMD }}</strong></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else-if="coupon.DISP_IMAGE_KBN == 1" class="couponItemRight">
                                        <ul class="couponInfo">
                                            <li>
                                                <div v-if="coupon.USE_JOUKEN == '2'" class="couponObjectCondition1">
                                                    <a v-on:click="showItemListModal(coupon.COUPON_CD)" href="javascript:void(0)">
                                                        {{ $t('pt485.labels.couponConditionShohin') }}
                                                        <img clas="couponObjectImg" :src="getImageOpenNewWindow" alt="対象商品">
                                                    </a>
                                                </div>
                                                <img class="couponImg" :src="coupon.IMG_URL1">
                                                <div class="fuyoYmd1">{{ $t('pt485.labels.fuyoYmd') }}<strong>{{ coupon.FUYO_YMD }}</strong></div>                                                
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else-if="coupon.DISP_IMAGE_KBN == 2" class="couponItemRight">
                                        <ul class="couponInfo">
                                            <li>
                                                <span v-html="coupon.CSS_TXT"></span>                                      
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        
        <alert-confirm
            v-if="isModalShow"
            :title = "$t('pt485.labels.couponConditionShohin')"
            v-bind:msgConfirm="shonHinList"
            :okAction="closeShonHinList"
            :isButtonOK="true"
            :isButtonCancel="false"
            bodyText=""
            @closedModal="isModalShow = false"
            size="md"
        />
        <alert-confirm
            v-if="isKakuteiModalShow"
            :msgConfirm="$t('pt485.messages.updateCaption')"
            :okAction="kakutei"
            :cancelAction="()=>{isKakuteiModalShow = false;}"
            @closedModal="isKakuteiModalShow = false"
        />
    </div>
</template>
<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import InputCheck from "components/InputCheck.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "assets/js/request";
import Message from 'components/MessageEcSite';
import EventBus from 'assets/js/eventBus';
import AlertConfirm from 'components/AlertConfirm';

export default {
    /*
    * Name of component
    */
    name: "PT485MemberCouponListParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        Breadcrumb,
        Loading,
        InputCheck,
        Message: Message,
        AlertConfirm
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            PT485_PART: "pt485",
            listMessValid:[],
            mapMessValid:[],
            showFlg: false,
            isModalShow: false,
            isKakuteiModalShow: false,
            shonHinList: '',
            msgConfirm: '',
            isLoading: false,
            isDisplaySortFlg: true,
            pt485ReqModel: {},
            pt485Init: {
                couponList: [],
                descriptionInfo:{},
            },
            descriptionInfo:[],
            SiteConstants: SiteConstants,
            site: "",
            getImageOpenNewWindow: common.getImages('openNewWindow'),
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            if(_this.ptInitData.isLogin == false){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            }else{
                _this.pt485Init = _this.ptInitData;
                _this.descriptionInfo = _this.pt485Init.descriptionInfo;
                if(_this.ptInitData.couponList != null){
                    if(_this.ptInitData.couponList.length > 0){
                        _this.showFlg = true;
                        if (_this.pt485ReqModel.modeKbn == '1'){
                            for (let i=0; i<_this.pt485Init.couponList.length; i++){
                                let coupon = _this.pt485Init.couponList[i];
                                if (coupon.COUPON_DISABLED == '1' || coupon.NOT_USE_JOUKEN_KIN_FLG == '1' || coupon.NOT_USE_SYOHIN_FLG == '1' || coupon.USE_LIMIT_YMD_FROM_FLG == '1' || coupon.SYOHIN_QTY_LIMITED_FLG == '1'){
                                    if (coupon.COUPON_SELECTED == 1){
                                        coupon.COUPON_SELECTED = 0;
                                    }
                                }
                            }
                            for (let i=0; i<_this.pt485Init.couponList.length; i++){
                                let coupon = _this.pt485Init.couponList[i];
                                _this.selectedCoupon(coupon.COUPON_CD, coupon.COUPON_SELECTED, coupon.HEIYOU_FLG);
                            }
                        }
                    }else{
                        _this.showFlg = false;
                    }
                }
                if (_this.pt485Init.sortKbnList != null && _this.pt485Init.sortKbnList.length > 0) {
                    _this.pt485Init.isDisplaySortFlg = true;
                } else {
                    _this.pt485Init.isDisplaySortFlg = false;
                }
                _this.pt485ReqModel = Object.assign({}, _this.pt485ReqModel, _this.ptInitData.reqModel);
            }
        }
    },
    /*
    * Methods
    */
    methods: {
        closeShonHinList: function(){
            this.isModalShow = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
         handleCancel(evt){
            evt.preventDefault();
            this.isModalShow = false;
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * 数の3桁毎のカンマ処理
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        /*
        * 検索
        */
        reSearch: function() {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT485_PART);

            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT485 + _this.$UrlConstants.DO_SEARCH, _this.pt485ReqModel).then(function(response) {
                _this.pt485Init.couponList = response.data.couponList;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * クーポン追加
        */
        add: function() {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT485_PART);

            if (!_this.pt485ReqModel.searchCouponCd) {
                return false;
            }

           _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT485 + _this.$UrlConstants.DO_INSERT, _this.pt485ReqModel).then(function(response) {
                let errorCode = response.data.errorCode;
                if (errorCode == 0){
                    _this.pt485Init.couponList = Object.assign([], _this.pt485Init.couponList, response.data.couponList);
                    if (response.data.couponList.length > 0){
                        _this.showFlg = true;
                    }
                }else{
                    _this.listMessValid = [];
                    if (errorCode == 1){
                        _this.listMessValid.push(_this.$i18n.t('pt485.messages.noDataMessage'));
                    }else if (errorCode == 2){
                        _this.listMessValid.push(_this.$i18n.t('pt485.messages.existsDataMessage'));
                    }else if (errorCode == 3){
                        _this.listMessValid.push(_this.$i18n.t('pt485.messages.usedMessage'));
                    }else if (errorCode == 4){
                        _this.listMessValid.push(_this.$i18n.t('pt485.messages.dateMessage'));
                    }

                    if(_this.listMessValid.length > 0) {
                        EventBus.$emit('message', {});
                        common.scrollTop();
                    }
                }
                _this.pt485ReqModel.searchCouponCd = "";
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * クーポンチェックボックス選択
        */
        selectedCoupon: function(cd,selected,heiyouFlg) {
            var _this = this;
            for (let i=0; i<_this.ptInitData.couponList.length; i++){
                let couponCd = _this.ptInitData.couponList[i].COUPON_CD;
                if (couponCd != cd){
                    if (selected && heiyouFlg == '0'){
                        _this.ptInitData.couponList[i].COUPON_SELECTED = false;
                        _this.ptInitData.couponList[i].COUPON_DISABLED = '1';
                    }else{
                        if (selected && _this.ptInitData.couponList[i].HEIYOU_FLG == '0'){
                        _this.ptInitData.couponList[i].COUPON_SELECTED = false;
                        _this.ptInitData.couponList[i].COUPON_DISABLED = '1';
                    }
                    }

                }
            }
            let checkedCnt = 0;
            for (let i=0; i<_this.ptInitData.couponList.length; i++){
                if (_this.ptInitData.couponList[i].COUPON_SELECTED == 1){
                    checkedCnt = checkedCnt + 1;
                }
            }
            if (checkedCnt == 0){
                for (let i=0; i<_this.ptInitData.couponList.length; i++){
                    _this.ptInitData.couponList[i].COUPON_DISABLED = '0';
                }
            }
        },
        /*
        * クーポン確定
        */
        kakutei: function() {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            _this.isKakuteiModalShow = false;

            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT485 + _this.$UrlConstants.DO_UPDATE, _this.pt485ReqModel).then(function(response) {
                let errorCode = response.data.errorCode;
                if (errorCode == 0){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN , query: {pageNo: 22}});
                }else{
                    _this.listMessValid = [];
                    if (errorCode == 1){
                        _this.listMessValid.push(_this.$i18n.t('pt485.messages.updateError'));
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        kakuteiCheck: function() {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr, _this.PT485_PART);

            var selectedCouponCd = [];
            for (let i=0; i<_this.ptInitData.couponList.length; i++){
                let check = _this.ptInitData.couponList[i].COUPON_SELECTED;
                if (check){
                    selectedCouponCd.push(_this.ptInitData.couponList[i].COUPON_CD);
                }
            }
            
            _this.pt485ReqModel.selectedCouponCdList = selectedCouponCd;

            if (_this.pt485ReqModel.selectedCouponCdList.length > 0) {
                _this.$emit("event-loading", true);
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT485 + _this.$UrlConstants.DO_CHECK, _this.pt485ReqModel).then(function(response) {
                    let errorCode = response.data.errorCode;
                    if (errorCode == 0){
                        _this.$emit("event-loading", false);
                        _this.kakutei();
                    } else {
                        console.log("error");
                        _this.isKakuteiModalShow = true;
                    }
                    _this.$emit("event-loading", false);
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            }else{
                _this.kakutei();
            }
        },
        /**
         * クーポン商品の取得
         * @param {*} couponCd 
         */
        showItemListModal: function(couponCd){
            var _this = this;
            _this.shonHinList = "";
            _this.$emit("event-loading", true);
            _this.pt485ReqModel.couponCd = "";
            _this.pt485ReqModel.couponCd = couponCd;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT485 + _this.$UrlConstants.DO_AJAX, _this.pt485ReqModel).then(function(response) {
                let list = response.data.couponItemList;
                if (list != null && list.length > 0){
                    for (let i=0; i<list.length; i++){
                        if (_this.shonHinList == ""){
                            _this.shonHinList = list[i].M_ITEM_CD + " " + list[i].WEB_ITEM_NM;
                        }else{
                            _this.shonHinList = _this.shonHinList + "<br>" +  list[i].M_ITEM_CD + " " + list[i].WEB_ITEM_NM;
                        }
                    }
                }
                _this.pt485ReqModel.couponCd = "";
                _this.$emit("event-loading", false);
                _this.isModalShow = true;
            }).catch(function(error) {
                _this.pt485ReqModel.couponCd = "";
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });

            
        }
    },
    created(){
        this.queryData = this.$route.query;
        this.paramsData = this.$route.params;
        if (this.queryData != null){
            if(this.queryData.modeKbn != null){
                this.pt485ReqModel.modeKbn = this.queryData.modeKbn;
            }else{
                this.pt485ReqModel.modeKbn = "0";
            }
            if(this.queryData.sortKbn != null){
                this.pt485ReqModel.sortKbn = this.queryData.sortKbn;
            }else{
                this.pt485ReqModel.sortKbn = "1";
            }
            if(this.queryData.searchCouponCd != null){
                this.pt485ReqModel.searchCouponCd = this.queryData.searchCouponCd;
            }
        }else if (this.paramsData != null){
            if(this.paramsData.modeKbn != null){
                this.pt485ReqModel.modeKbn = this.paramsData.modeKbn;
            }else{
                this.pt485ReqModel.modeKbn = "0";
            }
            if(this.paramsData.sortKbn != null){
                this.pt485ReqModel.sortKbn = this.paramsData.sortKbn;
            }else{
                this.pt485ReqModel.sortKbn = "1";
            }
            if(this.paramsData.searchCouponCd != null){
                this.pt485ReqModel.searchCouponCd = this.paramsData.searchCouponCd;
            }
        }
    },
}
</script>